import { TypeResponse } from 'gtd-ng-widget';
export class ProfileResponse extends TypeResponse {
  id: number;
  name: string;
  formula: string;
  hint: string;
  short_name: string;
  created_at: number;
  updated_at: number;
}
